import React from 'react';
import { Grid, Paper, Box, Typography, ButtonBase, Badge } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { theme } from '../../../../App/MuiTheme';

const styles = theme => ({
    button: {
        borderRadius: theme.shape.borderRadius,
        '&:hover': {
            '& $ripple': {
                background: theme.palette.action.hover,
            }
        },
    },
    paper: {
        textAlign: 'center',
        width: theme.spacing(8),
        height: theme.spacing(8),
        padding: theme.spacing(1) / 2,
    },
    ripple: {
        transition: theme.transitions.create('background', {
			easing: theme.transitions.easing.easeInOut,
			duration: theme.transitions.duration.shortest,
		}),
    },
    rippleActive: {
        background: theme.palette.action.selected
    },
    container: {
        width: '100%',
        height: '100%'
    },
    // icon: {
    //     fontSize: 12
    // },
    text: {
        fontSize: 11,
        fontWeight: 500
    },
});

const SettingsPanelButtonBadge = withStyles(Badge, {
    badge: {
        fontSize: '0.65rem',
        right: 6
    }
});

class SettingsPanelButton extends React.Component {
    render() {
        const { classes, children, icon, active, badge,  ...other} = this.props

        return (
            <SettingsPanelButtonBadge 
                badgeContent={badge ? badge : ''} 
                color='primary'
                invisible={!Boolean(badge)}
            >
                <ButtonBase
                    className={classes.button}
                    {...other}
                    focusRipple
                    TouchRippleProps={{
                        className: classes.ripple + ' ' + (active ? classes.rippleActive : ''),
                    }}
                >
                    <Paper 
                        className={classes.paper} 
                    >
                        <Grid
                            container
                            direction='column'
                            justifyContent='space-around'
                            alignItems='center'
                            className={classes.container}
                        >
                            <Grid>
                                <Box 
                                    className={classes.icon}
                                    style={{color: active ? theme.palette.text.primary : theme.palette.text.secondary}}
                                >
                                    {icon}
                                </Box>
                            </Grid>
                            <Grid>
                                <Typography 
                                    className={classes.text}
                                    color={active ? 'textPrimary' : 'textSecondary'}
                                >
                                    {children}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </ButtonBase>
            </SettingsPanelButtonBadge>
        );
    }
}

export default withStyles(SettingsPanelButton, styles);